<template>
  <div id="christmas-clock" ref="clockContainer">
    <!-- Animación de Santa izquierda -->
    <div id="santa-left" class="santa-decoration"></div>
    
    <div class="flip-container">
      <div class="time-section">
        <div class="flip-card" v-for="(digit, index) in days" :key="'d' + index">
          <div class="flip-card-inner">
            <div class="flip-card-front">{{ digit }}</div>
          </div>
        </div>
      </div>
      
      <span class="divider">:</span>
      <div class="time-section">
        <div class="flip-card" v-for="(digit, index) in hours" :key="'h' + index">
          <div class="flip-card-inner">
            <div class="flip-card-front">{{ digit }}</div>
          </div>
        </div>
      </div>
      
      <span class="divider">:</span>
      <div class="time-section">
        <div class="flip-card" v-for="(digit, index) in minutes" :key="'m' + index">
          <div class="flip-card-inner">
            <div class="flip-card-front">{{ digit }}</div>
          </div>
        </div>
      </div>
      
      <span class="divider">:</span>
      <div class="time-section">
        <div class="flip-card" v-for="(digit, index) in seconds" :key="'s' + index">
          <div class="flip-card-inner">
            <div class="flip-card-front">{{ digit }}</div>
          </div>
        </div>
      </div>
      
    </div>
    
    <!-- Animación de Santa derecha -->
    <div id="santa-right" class="santa-decoration"></div>
  </div>
</template>

<script>
export default {
  name: 'ChristmasCountdown',
  
  data() {
    return {
      countdownInterval: null,
      days: ['0', '0'],
      hours: ['0', '0'],
      minutes: ['0', '0'],
      seconds: ['0', '0']
    };
  },

  mounted() {
    this.updateCountdown();
    this.startCountdown();
    
    // Inicializar animaciones de Lottie para Santa
    this.$nextTick(() => {
      if (window.lottie) {
        // Santa izquierda
        const santaLeftContainer = document.getElementById('santa-left');
        if (santaLeftContainer) {
          window.lottie.loadAnimation({
            container: santaLeftContainer,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/static/navidad.json'
          });
        }
        
        // Santa derecha
        const santaRightContainer = document.getElementById('santa-right');
        if (santaRightContainer) {
          window.lottie.loadAnimation({
            container: santaRightContainer,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/static/navidad.json'
          });
        }
      }
    });
  },

  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },

  methods: {
    getTimeUntilChristmas() {
      const now = new Date();
      const christmas2026 = new Date(2026, 11, 25, 0, 0, 0);
      const difference = christmas2026.getTime() - now.getTime();

      if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      return { days, hours, minutes, seconds };
    },

    updateCountdown() {
      const timeLeft = this.getTimeUntilChristmas();
      
      this.days = String(timeLeft.days).padStart(2, '0').split('');
      this.hours = String(timeLeft.hours).padStart(2, '0').split('');
      this.minutes = String(timeLeft.minutes).padStart(2, '0').split('');
      this.seconds = String(timeLeft.seconds).padStart(2, '0').split('');
    },

    startCountdown() {
      this.countdownInterval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }
  }
};
</script>

<style scoped>
#christmas-clock {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.santa-decoration {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#santa-left {
  margin-right: 10px;
}

#santa-right {
  margin-left: 10px;
}

.flip-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.time-section {
  display: flex;
  align-items: center;
  gap: 3px;
}

.flip-card {
  width: 15px;
  height: 25px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card-front {
  position: absolute;
  width: 110%;
  height: 82%;
  backface-visibility: hidden;
  background: linear-gradient(to bottom, #c41e3a 0%, #8b1a2e 50%, #c41e3a 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: bold;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3), inset 0 1px 2px rgba(255, 255, 255, 0.2);
  border: 2px solid #ffffff;
  position: relative;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}


.divider {
  font-size: 0.9rem;
  font-weight: bold;
  color: #c41e3a;
  margin: 0 3px;
}

.label {
  font-size: 0.6rem;
  color: #666;
  text-transform: uppercase;
  font-weight: bold;
  margin-left: 2px;
}
</style>